<template>
  <div class="hello">
    
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.hello{
  width: 100vw;
  height: 100vh;
  background: url(../upload/191403.jpg) no-repeat center center/100%;
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue